import * as React from 'react';
import { LocalForm, Control, Errors } from 'react-redux-form';
import { hasValue } from '@common/validators';

import { Column } from 'react-table';
import { Link } from 'react-router-dom';
import { getRoute } from '@common/route-definitions';
import { RouteDefinitions } from '@common/route-definitions';
import { getDefaultErrorMessages } from '@common/validators';
import ReactTable from 'react-table';
import { PropertyManagerSearchViewModel } from '@models/PropertyManager';
// import { PropertyManagerViewModel } from '../../../_services/PropertyManagerService';
import { Role, Roles } from '@models/Roles';
import { TooltipComponent } from '@common/components/tooltip/tooltip.component';

export interface PropertyManagerSearchComponentProperties {
  readonly getPropertyManagerSearch: (
    query: string | null,
    pageSize: number,
    pageNumber: number,
    orderBy: string,
    orderDirection: string
  ) => void;
  readonly message: string;
  readonly query: string | null;
  readonly propertyManagers: PropertyManagerSearchViewModel[];
  readonly propertyManagerLoading: boolean;
  readonly propertyManagerPageNumber: number;
  readonly propertyManagerPageSize: number;
  readonly propertyManagerOrderBy: string;
  readonly propertyManagerPageCount: number;
}

interface FormModel {
  readonly query: string;
}

export class PropertyManagerSearchComponent extends React.Component<PropertyManagerSearchComponentProperties> {
  isInitialized: boolean = false;
  render() {
    const columns: Column[] = [
      {
        accessor: 'name',
        Header: 'Name',
        Cell: (props: { value: number; original: PropertyManagerSearchViewModel }) => (
          <Link to={getRoute(RouteDefinitions.propertymanager.Details, { id: props.original.id })} target="_blank">
            {props.value}
          </Link>
        ),
        sortable: true
      },
      {
        accessor: 'phone',
        Header: 'Phone',
        maxWidth: 300,
        sortable: true
      },
      {
        accessor: 'emailAddress',
        Header: 'Email',
        sortable: true
      },

      {
        accessor: 'officeName',
        Header: 'Office Name',
        Cell: (props: { value: number; original: { office: PropertyManagerSearchViewModel } }) => (
          <Link
            to={getRoute(RouteDefinitions.propertymanagementoffice.Details, { id: props.original.office.id })}
            target="_blank"
          >
            {props.original.office.name}
          </Link>
        ),
        sortable: true
      }
    ];

    return (
      <div>
        <LocalForm
          className="form-horizontal"
          hideNativeErrors={true}
          onSubmit={(props: FormModel) => this.handleSearch(props.query)}
        >
          <div className="row">
            <div className="col-md-12">
              <h2>Property Managers</h2>
            </div>
            <div className="form-control col-md-12">
              <label htmlFor=".query">Search</label>
              <TooltipComponent text="Search by Name, Email or Phone" side="top" />
              <Control.text model=".query" validators={{ hasValue: hasValue }} />
              <Errors
                className="error"
                model=".query"
                show={{ touched: true, focus: false }}
                messages={getDefaultErrorMessages()}
              />
              {this.props.propertyManagerPageCount * 10 > 10000 && (
                <span> Your search is too broad. Narrow the search with more specific terms. </span>
              )}
            </div>
            <div className="col-md-12">
              <div className="row end-xs text-right">
                <button className="btn btn-primary" disabled={this.props.propertyManagerLoading} type="submit">
                  Search
                </button>
              </div>
            </div>
          </div>
        </LocalForm>
        <ReactTable
          onPageChange={() => {
            Array.from(document.getElementsByClassName('rt-tbody')).forEach(element => {
              element.scrollTop = 0;
            });
          }}
          className="-striped -highlight"
          columns={columns}
          data={this.props.propertyManagers}
          defaultPageSize={10}
          loading={this.props.propertyManagerLoading}
          manual={true}
          onFetchData={this.handleFetchData}
          pages={this.props.propertyManagerPageCount}
        />
        {Role.CheckRoles([Roles.Admin, ...Role.GetAllIBS()]) && (
          <Link className="btn btn-primary" to={RouteDefinitions.propertymanager.Create}>
            Create New
          </Link>
        )}
      </div>
    );
  }

  private handleFetchData = (state: {
    page: number;
    pageSize: number;
    sorted: Array<{ id: string; desc: string }>;
  }): void => {
    if (this.isInitialized) {
      const orderBy = state.sorted ? state.sorted[0].id : 'id';
      // const orderDesc = state.sorted ? state.sorted[0].desc : true;
      const orderDirection = state.sorted[0] ? (state.sorted[0].desc ? 'desc' : 'asc') : 'asc';
      this.props.getPropertyManagerSearch(this.props.query, state.pageSize, state.page + 1, orderBy, orderDirection);
    }

    this.isInitialized = true;
  };

  private handleSearch = (query: string | null): void => {
    this.isInitialized = true;
    this.props.getPropertyManagerSearch(query, this.props.propertyManagerPageSize, 1, 'id', 'asc');
  };
}



// WEBPACK FOOTER //
// ./src/property-manager/_components/property-manager-search/property-manager-search.component.tsx